// extracted by mini-css-extract-plugin
module.exports = {"emojiBox":"EmojiBox_emojiBox__183sW","selected":"EmojiBox_selected__1MSlP","emoji":"EmojiBox_emoji__R8Hwv","emojiText":"EmojiBox_emojiText__3nHmG"};